export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-1-480-1728326769f5f6e9927a1d16ff1a1701.png";